module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')])]), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_fm1_r1"
    }
  }, [_vm._v("USING THIS BOOK")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 1 - HOWDY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••You had me at “hello”  - Du hat mir vi “Sholom aleichem”")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Oy! Don’t ask!  - Oy! Frayg nisht!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Feelings, nothing more than feelings…  - Gefiln, gornisht mer vi gefiln…")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Greetings  - Grusn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••The long good-bye  - Di langeh gezehgenung")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Be polite!  - Zay heflekh!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Well, excuuuuuuse me!  - Zayyyyytyt moyyyyyyyyyykhl!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Nice to meet you  - Es frayt mikh dikh tsu kenen")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••What are you talking about?  - Vos retstu eppis?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c01_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••The questions  - Di fragehs")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2 - FRIENDLY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Friends  - Khaverim")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Who dat?  - Ver iz yener?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Personalities  - Perzenlekhkaytn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Strictly women  - Nor froys")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Non-Jews  - Goyim")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Sad sacks, nobodies, and pipsqueaks  - Shnooks, shmoes, un shmendriks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Fools and crazies  - Nars und mishuggeners")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Movers and shakers  - K’nockers un makhers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Pests  - Nudniks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Ignorant boors  - Proster mentshn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Dumb fucks  - Behaymehs")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Sleazeballs  - Paskoodniks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Assholes  - Shmucks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Decent human beings  - Menschen")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Socializing  - Zayn sotsyal")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c02_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Other ways of describing people  - Andereh bashraybn fur menschen")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3 - SNAPPY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Flavorful words  - Verters fun taam")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Interjections  - Oysrufvorts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c03_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Sarcasm  - Shpitzik")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c03_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Yinglish inflection and grammar  - Beygung un gramatik")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c03_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Common expressions  - Shprikhvorts")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4 - PARTY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Where’s the party?  - Voo iz di simcha?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••You’re wearing THAT!?  - Trogst du yentz?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Drinking booze  - Trinkn yash")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Drunk  - Shikker")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Drugs  - Narkotiks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Stoned  - Fleishig")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c04_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Holidays  - Yontovim")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5 - BODY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Beauty  - Shaynkeit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Ugliness  - Meeskeit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Other body parts  - Ander opteyln fun der guf")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Rear end  - Hintn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Breasts  - Bristin")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Sick  - Krenk")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Stop being such a hypochondriac!  - A lung un leber oyf der noz!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Pee  - Pishn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Shit  - Drek")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Disgustingness  - Khalusheskeit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c05_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Tired  - Fermahtert")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6 - HORNY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Screwing  - Shtupn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Licking and sucking  - Lekhn un zoygn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Kiss me!  - Kish mir!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Do you like it?  - Gefelt es dir?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Vagina  - Vagheena")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Penis  - Penis")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Virgin or whore?  - B’suleh oder nafka?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c06_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Oh, behave!  - Firn zikh!")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7 - ANGRY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Pissed off  - Tsegridjeneh")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Scram!  - Gai avek!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••A little angrier  - A bisl mir broygis")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Nasty talk  - Grobbeh rayd")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Angry in business  - Broygis in geshaft")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Now it’s getting physical!  - Verndik fizisheh!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c07_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Insults and name-calling  - Zidlvort in di oygn")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8 - CURSY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Sickness and physical discomfort  - Krenkheit un veytik")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Eating and indigestion  - Essen un boykhveytik")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Disaster and destruction  - Umglik un churbn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Misfortune on you!  - Eyn umglik oyf dir!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Curses with animals  - Brokhs mit behaymehs")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••A plague on them!  - A kholere oyf zay!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••A curse on you!  - A brokh tsu dir!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c08_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Yiddish-inspired cursing in English   - Yiddishe-nosakh fur klole in Anglish")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - HUNGRY YIDDISH")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Eat, pray, and be a decent human being!  - Ess, bench, un sei a mensch!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Kosher  - Kashrus")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Tasty!  - Batampt!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••To cook  - Kukhn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Eat! Eat!  - Ess! Ess!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••From the deli  - Fun di vurshteray")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Dessert  - Farbaysn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Oh! Am I thirsty!  -  Oy! Bin Ikh darstik!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••Food-related proverbs and sayings -  Esn veltsvertl")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_c09_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••In the restaurant  -  In der restauran")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•••••About the author")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/adri_9781612430805_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7732fbdf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/adri_9781612430805_oeb_toc_r1.vue
// module id = 63
// module chunks = 0